import { Prisma } from "@prisma/client";

import { prisma } from "@/lib/prisma";

export async function getArticlesByApplicationId(applicationId: string) {
  return await prisma.applicantArticle.findMany({
    where: {
      applicant: {
        Application: {
          every: {
            id: applicationId,
          },
        },
      },
    },
    orderBy: { sortOrder: Prisma.SortOrder.asc },
  });
}
